import React, { useEffect, useState } from "react";
import TableAgents from "../TableAgents";

import s from "./styles.module.css";
import useAuth from "../../../../hooks/useAuth";
import { fetchAgents } from "../../model/agents";
import { useDispatch, useSelector } from "react-redux";

function AgentsList() {
  const dispatch = useDispatch();
  const { auth } = useAuth();
  const token = auth?.access_token;
  const agents = useSelector((state) => state.agents.agents);
  const [loadingData, setLoadingData] = useState(false);
  const [loadingError, setLoadingError] = useState(null);

  useEffect(() => {
    if (token) {
      setLoadingData(true);
      dispatch(fetchAgents(token))
        .then(() => setLoadingData(false))
        .catch((error) => {
          setLoadingData(false);
          console.log(error);
          setLoadingError(error.message);
        });
    }
  }, [dispatch, token]);

  if (loadingData) {
    return (
      <div className="loadingContainer">
        <div className="loader"></div>
      </div>
    );
  }
  if (loadingError) {
    return (
      <div className="errorDataBox">
        <p>{loadingError}</p>
      </div>
    );
  }
  return (
    <div className="container">
      {/* <SearchAgent /> */}
      <h1 className="title" style={{ marginBottom: 20 }}>
        Список агентов
      </h1>
      <div className={s.row}>
        <TableAgents agents={agents} />
      </div>
    </div>
  );
}

export default AgentsList;
